import React from 'react';
import { observer } from 'mobx-react'
import { styled } from "../../stitches.config"
import { h1 } from '../commonStyles/Fonts';
import QuoteIcon from "../assets/icons/quote-icon.svg";

type ExtendedProps = {
    backgroundImg?: any;
    large_quote?: string;
};

interface LiveDebateProps {
    data: ExtendedProps;
}

const LiveDebate: React.FC<LiveDebateProps> = observer(({
    data,
}) => {
    const {
        large_quote,
        backgroundImg,
    } = data;

    return (
        <DebateContent>
            {large_quote &&
                <>
                    <Quote>
                        <StyledQuoteIcon />
                        <h1 className={h1()}>{large_quote}</h1>
                    </Quote>
                </>
            }
            {backgroundImg.img && <img src={backgroundImg.img} />}
            <OpacityLayer />
        </DebateContent>
    );
});

const OpacityLayer = styled('div', {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    minHeight: "302px",
    height: "100%",
    zIndex: 2,
    background: "linear-gradient(0deg, rgba(19, 18, 18, 0.6), rgba(19, 18, 18, 0.6))",
    opacity: 1,
    "@bp4": {
        background: "linear-gradient(0deg, rgba(19, 18, 18, 0.4), rgba(19, 18, 18, 0.4))",
    },
})

const DebateContent = styled('div', {
    width: "100%",
    background: "linear-gradient(0deg, rgba(19, 18, 18, 0.4), rgba(19, 18, 18, 0.4))",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    position: "relative",
    height: "302px",
    "@bp4": {
        height: "488px",
    },
    "img": {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "302px",
        objectFit: "cover",
        "@bp4": {
            height: "488px",
        },
    }
})

const Quote = styled('div', {
    color: "$grayscale0Fixed",
    margin: "0 16px",
    position: "relative",
    zIndex: 10,
    "@bp4": {
        margin: "0 0 0 84px",
        maxWidth: "56%",
    },
    "h1": {
        margin: "21px 0 0 0",
        "@bp4": {
            margin: "32px 0 0 0",
        }
    }
})

const StyledQuoteIcon = styled('div', {
    width: "57px",
    height: "52px",
    backgroundImage: `url("${QuoteIcon}")`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    "@bp4": {
        width: "79px",
        height: "72px",
    }
})

export default LiveDebate